import { LEGACY_ICON_PARAM } from '../../shared/legacy-icon.js';

const LEGACY_KEY = 'aqs.legacy_icon';

export const isIos = (ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') =>
  /iphone|ipad|ipod/i.test(ua);

export const isStandalone = () =>
  (typeof window !== 'undefined' && window.matchMedia?.('(display-mode: standalone)').matches) ||
  (typeof navigator !== 'undefined' && navigator.standalone === true);

// Call once at boot. The server tags only the redirect that an old Home
// Screen icon's start_url takes, and every launch of that icon repeats the
// redirect, so session storage is enough. The tag is then dropped from the
// address bar so a copied link doesn't carry it.
export function noteLegacyIconLaunch({
  location = typeof window !== 'undefined' ? window.location : null,
  history = typeof window !== 'undefined' ? window.history : null,
  storage = typeof sessionStorage !== 'undefined' ? sessionStorage : null,
  standalone = isStandalone(),
} = {}) {
  if (!location) return false;
  const url = new URL(location.href);
  if (!url.searchParams.has(LEGACY_ICON_PARAM)) return false;
  url.searchParams.delete(LEGACY_ICON_PARAM);
  history?.replaceState?.(history.state, '', `${url.pathname}${url.search}${url.hash}`);
  if (!standalone) return false;
  try {
    storage?.setItem(LEGACY_KEY, '1');
  } catch {
    // private mode: the banner falls back to its normal copy
  }
  return true;
}

export function launchedFromLegacyIcon(
  storage = typeof sessionStorage !== 'undefined' ? sessionStorage : null
) {
  try {
    return storage?.getItem(LEGACY_KEY) === '1';
  } catch {
    return false;
  }
}

export const LEGACY_ICON_NOTE =
  'This Home Screen icon still opens our old address, and iPhone only allows alerts for the address an icon was added from. Delete this icon, open tanksensei.com in Safari, then tap Share and Add to Home Screen. Alerts you turn on from the new icon will work.';

// The words for a permission refusal, per device. Returns null for other
// reasons so each screen keeps its own copy for those.
export function permissionNote(
  reason,
  { ios = false, standalone = false, legacyIcon = false } = {}
) {
  if (reason !== 'denied' && reason !== 'dismissed') return null;
  if (ios && legacyIcon) return LEGACY_ICON_NOTE;
  if (reason === 'dismissed') {
    return 'Notifications are not on yet: the permission prompt closed without an answer. Try again and choose Allow.';
  }
  if (ios && standalone) {
    return 'Notifications are turned off for TankSensei on this iPhone. Open the Settings app, tap Notifications, then TankSensei, and turn on Allow Notifications. Then try again.';
  }
  return "Notifications are blocked for this site in your browser. Allow them in the browser's site settings, then try again.";
}

export const currentPushContext = () => ({
  ios: isIos(),
  standalone: isStandalone(),
  legacyIcon: launchedFromLegacyIcon(),
});
